import React, { useEffect, useState } from "react";

interface PdfPreviewProps {
  file: Blob;
}

const PdfPreview: React.FC<PdfPreviewProps> = ({ file }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    // 🔥 Force it to be treated as a PDF
    const fixedBlob = new Blob([file], { type: "application/pdf" });
    const url = URL.createObjectURL(fixedBlob);
    setPdfUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return (
    <div className="w-full h-full">
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="PDF Preview"
          className="w-full h-full"
          style={{ border: "none" }}
        />
      )}
    </div>
  );
};

export default PdfPreview;
